import React from 'react';
import { FiMic, FiPlay, FiVolume2, FiX } from 'react-icons/fi';
import { HiOutlinePause } from 'react-icons/hi2';
import { LuPanelRightOpen } from 'react-icons/lu';

export function formatSeconds(seconds) {
  const pad = (value) => String(value).padStart(2, '0');
  return `${pad(Math.floor(seconds / 3600))}:${pad(Math.floor((seconds % 3600) / 60))}:${pad(seconds % 60)}`;
}

export const getIdleSeconds = (idleFrom) => {
  if (!idleFrom) return 0;

  const start = new Date(idleFrom).getTime();
  const now = Date.now();

  return Math.floor((now - start) / 1000);
};

export function toneStyle(tone) {
  if (tone === 'blue') return { background: 'var(--blue-lt)', color: 'var(--blue)' };
  if (tone === 'amber') return { background: 'var(--amber-lt)', color: 'var(--amber)' };
  if (tone === 'green') return { background: 'var(--green-lt)', color: 'var(--green)' };
  return { background: '#f3e8ff', color: '#7c3aed' };
}

export function controlIcon(key) {
  if (key === 'pause') return <HiOutlinePause />;
  if (key === 'play') return <FiPlay />;
  if (key === 'volume') return <FiVolume2 />;
  if (key === 'mic') return <FiMic />;
  if (key === 'leave') return <LuPanelRightOpen />;
  return <FiX />;
}

export function getScreenButtonClass(screenKey, activeScreen) {
  if (screenKey !== activeScreen) return '';
  if (screenKey === 'ringing') return 'ringing-active';
  if (screenKey === 'oncall') return 'oncall-active';
  if (screenKey === 'conference') return 'conf-active';
  return 'active';
}
